import PropTypes from 'prop-types';

const MedalIcon = ({ className = '' }) => (
  <svg
    width="42"
    height="61"
    viewBox="0 0 42 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0.833496 0.761719C0.833496 11.8156 9.83577 20.7617 20.959 20.7617C32.0822 20.7617 41.0845 11.8156 41.0845 0.761719H0.833496Z"
      fill="#FFCCEF"
    />
    <path
      d="M20.959 20.7617C9.83577 20.7617 0.833496 29.7313 0.833496 40.7617C0.833496 51.8156 9.83577 60.7617 20.959 60.7617C32.0822 60.7617 41.0845 51.8156 41.0845 40.7617C41.0845 29.7313 32.0822 20.7617 20.959 20.7617ZM17.7069 48.0217L17.3062 47.6235L11.9803 42.3308L14.2898 40.0357L17.6833 43.4081L27.6282 33.5252L29.9377 35.8203L17.7069 48.0217Z"
      fill="#FB6E44"
    />
  </svg>
);

MedalIcon.propTypes = {
  className: PropTypes.string
};

export default MedalIcon;
